<template>
    <div>
        <Navigation />
        <section class="section__container spacer-8">

            <h1 class="title center__text">Un(e) analyste développeur (H/F)</h1>
            <div class="requirements container">
                <h3 class="requirements__title"> Nous recherchons un profil répondant aux critères suivants :</h3>
                <ul>
                    <li>Possédant une expérience professionnelle d'au moins deux ans dans un rôle similaire, de préférence au sein d'une TPE/PME</li>
                    <li>Doté(e) de compétences en langage web, notamment en PHP et MySQL</li>
                    <li>Organisé(e) et ayant un goût prononcé pour le travail en équipe</li>
                </ul>
                <h3 class="requirements__title"> Les principales missions seront les suivantes :</h3>
                <ul>
                    <li>Développer de nouveaux canaux pour notre plateforme</li>
                    <li>Contribuer à l'amélioration de nos outils</li>
                    <li>Assurer la maintenance des fonctionnalités existantes</li>
                    <li>Le contrat proposé est un CDI</li>
                </ul>
                <div class="other__requirements">
                    <h3>Comment postuler ?</h3>
                    <p>Pour candidater à ce poste, veuillez inclure votre CV en l'attachant à un e-mail adressé à

                        <a href="mailto:recrutement@servicesms.sn">recrutement@servicesms.sn</a>
                        , en utilisant comme objet "Analyste développeur (H/F)".
                    </p>

                </div>

            </div>
        </section>
        <Footer />
    </div>
</template>

<script>
import Navigation from './Navigation';
import Footer from './Footer';
export default {
    components: {
        Navigation,
        Footer
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/base.scss';

.requirements {
    box-shadow: 0 67px 139px 28px rgba(0, 0, 0, .05);
    border-radius: 25px 25px 25px 0;
    
}

.requirements__title {
    padding-left: 2rem;
    padding-top: 1rem;
}

.other__requirements {
    padding-left: 1rem;
    padding-bottom: 4rem;
}

li {
    list-style-type: none;
}

li::before {
    content: "";
    width: 15px;
    height: 15px;
    background: url(../../public/images/picto-list.svg) no-repeat center;
    padding-left: 2rem;
}

@media(min-width: 65rem) {
    .requirements {
        width: 60%;
        margin: 3rem auto;
    }

    .spacer-8 {
        margin-top: 8rem;
    }
    .title{
        padding-top: 3rem;
    }
}</style>